import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {SensorRestApiService} from '../http/sensor-rest-api.service';
import {Utils} from '@astek/utils';
import {ApiSensorResponse} from '../http/api-sensor-response';

@Injectable()
export class SensorResolver {

  constructor(
    private readonly _sensorRestApiService: SensorRestApiService,
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot): Observable<ApiSensorResponse> {
    if (Utils.isNullOrUndefined(route.params['sensorId'])) {
      throw new Error('Missing sensor id');
    }
    return this._sensorRestApiService.requestSensor(route.params['sensorId'] as string);
  }

}
